<template>
  <b-card>
    <div slot="header" class="pt-2">
      <slot name="header"></slot>
    </div>
    <slot name="formBody"></slot>
  </b-card>
</template>
<script type="text/javascript">
export default {
  name: 'FITFormCard',
  props: {
    title: {
      type: String
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Form/FITFormCard.vue